import * as React from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { animated } from 'react-spring';

import { Container } from '../../../layout/Container';

import { Heading } from '../../../ui/text/Heading';
import { Paragraph } from '../../../ui/text/Paragraph';

import { useFadeTransition } from '../../../../utils/hooks/useFadeTransition';
import { Seo } from '../../../../utils/seo/Index';

import { BaseHeroContent, Hero } from '../../../ui/hero/Index';

const SalgAvFritidsbolig: React.FC = () => {
  const location = useLocation();
  const { fadeIn: pageFadeIn } = useFadeTransition({
    immidiate: true
  });

  return (
    <>
      <Seo
        title="Vurderer du å selge din fritidseiendom? - Privatmegleren Park"
        description="PrivatMegleren Park består av engasjerte og kompetanserike meglere som i tillegg benytter seg av bransjens mest kraftfulle verktøy innen markedsføring. Hvert lille steg i prosessen er tilpasset akkurat deg og din fritidseiendom."
        url={location.pathname}
      />
      <Hero
        imageUrl="https://cdn.reeltime.no/pm_assets/content/park/sylvtjonn.jpeg"
        opacity={0.4}
        height="600px"
        className="top-header-margin"
        alt="bilde"
      >
        <HeroContent style={pageFadeIn}>
          <Heading tag="h1" center={true}>
            Vurderer du å selge din fritidseiendom?
          </Heading>
          <Paragraph center={true}>
            PrivatMegleren Park består av engasjerte og kompetanserike meglere
            som i tillegg benytter seg av bransjens mest kraftfulle verktøy
            innen markedsføring. Hvert lille steg i prosessen er tilpasset
            akkurat deg og din fritidseiendom.
          </Paragraph>
        </HeroContent>
      </Hero>
      <Container
        className="padding-top"
        style={{ ...pageFadeIn, paddingTop: '40px' }}
      >
        <Paragraph center>
          Jeg er fra Treungen og kjennskapen og begeistringen for stedet er
          stor. Jeg kan gi gode råd og tips om alt fra populære gåturer,
          badesteder, skiløyper etc. til lokale håndverkere, byggevarer eller
          alarmtjenester.
        </Paragraph>
        <Paragraph center>
          Etter flere år med hyttesalg har jeg opparbeidet meg en stor
          portefølje med aktuelle kjøpere for din hytte. Det siste året har
          Privatmegleren hele 43% markedsandel på alle salgene i kommunen. Ref.
          eiendomsverdi.
        </Paragraph>
        <Paragraph center>
          Ønsker du å vite mer? Jeg er alltid tilgjengelig, ser frem til å høre
          fra deg.
        </Paragraph>
        <Paragraph center>
          Lars Jakob Aarak
          <br />
          Salgsleder | Partner | Eiendomsmegler MNEF
          <br />
          Tlf. <a href="tel:92285376 ">922 85 376</a> •{' '}
          <a href="mailto:aarak@privatmegleren.no">aarak@privatmegleren.no</a>{' '}
          <br />
          <a href="https://privatmegleren.no/park">
            https://privatmegleren.no/park
          </a>
        </Paragraph>
      </Container>
    </>
  );
};

export default SalgAvFritidsbolig;

const HeroContent = styled(animated.div)`
  ${BaseHeroContent}
  flex-flow: column;
  max-width: 960px;
`;
